import { Popconfirm, Button } from 'antd'
import { baseAxiosComplete } from '../../tool/axios'

// 删除
interface DeleteButtonProp {
    url: string,
    record: any,
    cb: () => void
}

const DeleteButton: React.FC<DeleteButtonProp> = (props: DeleteButtonProp) => {
    return <Popconfirm
        title="确定删除?"
        onConfirm={() => {
            baseAxiosComplete.post(props.url, {
                id: props.record.id
            }).then(res => {
                if (res.status === 0) { props.cb() }
            })
        }}
        okText="是"
        cancelText="否"
    >
        <Button size="small">删除</Button>
    </Popconfirm>
}

// 上下架
interface PutOnOffButtonProp {
    url: string,
    record: any,
    type: string,
    cb: () => void
}

const PutOnOffButton: React.FC<PutOnOffButtonProp> = (props: PutOnOffButtonProp) => {
    return <Popconfirm
        title={`确定${props.type === 'on' ? '上架' : '下架'}？`}
        onConfirm={() => {
            baseAxiosComplete.post(`${props.url}${props.type}`, {
                id: props.record.id
            }).then(res => {
                if (res.status === 0) { props.cb() }
            })
        }}
        okText="是"
        cancelText="否"
    >
        <Button size="small">{props.type === 'on' ? '上架' : '下架'}</Button>
    </Popconfirm>
}

// 上下架，支持批量
interface PutOnOffsButtonProp {
    url: string,
    ids: string[],
    type: string,
    cb: () => void
}

const PutOnOffsButton: React.FC<PutOnOffsButtonProp> = (props: PutOnOffsButtonProp) => {
    return <Popconfirm
        title={`确定${props.type === 'on' ? '上架' : '下架'}？`}
        onConfirm={() => {
            baseAxiosComplete.post(`${props.url}`, {
                id_arr: props.ids,
                operate_type: props.type === 'on' ? 1 : 2
            }).then(res => {
                if (res.status === 0) { props.cb() }
            })
        }}
        okText="是"
        cancelText="否"
    >
        <Button size="small">{props.type === 'on' ? '上架' : '下架'}</Button>
    </Popconfirm>
}

// 月子 上下架
interface PutOnOffsButtonPropYz {
    url: string,
    id: string,
    type: string,
    cb: () => void
}

const PutOnOffsButtonYZ: React.FC<PutOnOffsButtonPropYz> = (props: PutOnOffsButtonPropYz) => {
    return <Popconfirm
        title={`确定${props.type === 'on' ? '上架' : '下架'}？`}
        onConfirm={() => {
            baseAxiosComplete.post(`${props.url}`, {
                id: props.id,
                operate_type: props.type === 'on' ? 1 : 2
            }).then(res => {
                if (res.status === 0) { props.cb() }
            })
        }}
        okText="是"
        cancelText="否"
    >
        <Button size="small">{props.type === 'on' ? '上架' : '下架'}</Button>
    </Popconfirm>
}

export { DeleteButton, PutOnOffButton, PutOnOffsButton, PutOnOffsButtonYZ }